var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "labs"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8050_71310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8050_71310)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "labs_2",
    d: "M10.0001 18.3327C8.8473 18.3327 7.86467 17.9264 7.05217 17.1139C6.23966 16.3014 5.83341 15.3188 5.83341 14.166V6.66602C5.37508 6.66602 4.98272 6.50282 4.65633 6.17643C4.32994 5.85004 4.16675 5.45768 4.16675 4.99935V3.33268C4.16675 2.87435 4.32994 2.48199 4.65633 2.1556C4.98272 1.82921 5.37508 1.66602 5.83341 1.66602H14.1667C14.6251 1.66602 15.0174 1.82921 15.3438 2.1556C15.6702 2.48199 15.8334 2.87435 15.8334 3.33268V4.99935C15.8334 5.45768 15.6702 5.85004 15.3438 6.17643C15.0174 6.50282 14.6251 6.66602 14.1667 6.66602V14.166C14.1667 15.3188 13.7605 16.3014 12.948 17.1139C12.1355 17.9264 11.1529 18.3327 10.0001 18.3327ZM10.0001 16.666C10.5417 16.666 11.0279 16.5098 11.4584 16.1973C11.889 15.8848 12.1876 15.4855 12.3542 14.9993H10.0001V13.3327H12.5001V12.4993H10.0001V10.8327H12.5001V9.99935H10.0001V8.33268H12.5001V6.66602H7.50008V14.166C7.50008 14.8605 7.74314 15.4507 8.22925 15.9368C8.71536 16.423 9.30564 16.666 10.0001 16.666Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabs);
export default __webpack_public_path__ + "static/media/labs.8ded8a1736abc132841af6eca73dd347.svg";
export { ForwardRef as ReactComponent };